<template>
  <form id="frm_action">
    <div class="p-formgrid">
      <div class="mt-3">
        <div style="display:flex;">
          <label class="txt-right cust-name">{{evaluation_name}}</label>
        </div>
        <div style="display:flex;">
          <svg class="svg-cus-1" width="24px" height="24px" viewBox="0 -960 960 960" fill="#0086c4" stroke="#0086c4"><path stroke="#0086c4" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M80-80v-481l280-119v80l200-80v120h320v480H80Zm80-80h640v-320H480v-82l-200 80v-78l-120 53v347Zm280-80h80v-160h-80v160Zm-160 0h80v-160h-80v160Zm320 0h80v-160h-80v160Zm280-320H680l40-320h120l40 320ZM160-160h640-640Z"/></svg>
          <span class="txt-right cuss-text">{{title_1}}</span>
        </div>
        <div style="display:flex;">
        <svg class="svg-cus-1" width="24px" height="24px" viewBox="0 -960 960 960" fill="#0086c4" stroke="#0086c4"><path d="M42-120v-112q0-33 17-62t47-44q51-26 115-44t141-18q77 0 141 18t115 44q30 15 47 44t17 62v112H42Zm80-80h480v-32q0-11-5.5-20T582-266q-36-18-92.5-36T362-320q-71 0-127.5 18T142-266q-9 5-14.5 14t-5.5 20v32Zm240-240q-66 0-113-47t-47-113h-10q-9 0-14.5-5.5T172-620q0-9 5.5-14.5T192-640h10q0-45 22-81t58-57v38q0 9 5.5 14.5T302-720q9 0 14.5-5.5T322-740v-54q9-3 19-4.5t21-1.5q11 0 21 1.5t19 4.5v54q0 9 5.5 14.5T422-720q9 0 14.5-5.5T442-740v-38q36 21 58 57t22 81h10q9 0 14.5 5.5T552-620q0 9-5.5 14.5T532-600h-10q0 66-47 113t-113 47Zm0-80q33 0 56.5-23.5T442-600H282q0 33 23.5 56.5T362-520Zm300 160-6-30q-6-2-11.5-4.5T634-402l-28 10-20-36 22-20v-24l-22-20 20-36 28 10q4-4 10-7t12-5l6-30h40l6 30q6 2 12 5t10 7l28-10 20 36-22 20v24l22 20-20 36-28-10q-5 5-10.5 7.5T708-390l-6 30h-40Zm20-70q12 0 21-9t9-21q0-12-9-21t-21-9q-12 0-21 9t-9 21q0 12 9 21t21 9Zm72-130-8-42q-9-3-16.5-7.5T716-620l-42 14-28-48 34-30q-2-5-2-8v-16q0-3 2-8l-34-30 28-48 42 14q6-6 13.5-10.5T746-798l8-42h56l8 42q9 3 16.5 7.5T848-780l42-14 28 48-34 30q2 5 2 8v16q0 3-2 8l34 30-28 48-42-14q-6 6-13.5 10.5T818-602l-8 42h-56Zm28-90q21 0 35.5-14.5T832-700q0-21-14.5-35.5T782-750q-21 0-35.5 14.5T732-700q0 21 14.5 35.5T782-650ZM362-200Z"/></svg>
          <span class="txt-right cuss-text">{{title_2}}</span>
        </div>
        <div style="display:flex;">
          <svg class="svg-cus-1" width="24px" height="24px" viewBox="0 0 32 32" fill="none" stroke="#0086c4"><path stroke="#0086c4" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15.12 4.623a1 1 0 011.76 0l11.32 20.9A1 1 0 0127.321 27H4.679a1 1 0 01-.88-1.476l11.322-20.9zM16 18v-6"></path> <path fill="#0086c4" d="M17.5 22.5a1.5 1.5 0 11-3 0 1.5 1.5 0 013 0z"></path></svg>
          <span class="txt-right cuss-text">Nhóm mối nguy: {{title_3}}</span>
        </div>
      </div>
      <div class="mt-3">
        <label class="txt-right">ĐÁNH GIÁ RỦI RO</label>
      </div>
      <div class="mt-3">
        <table id="tb_level">
          <tr>
            <th style="width: 60px;">STT</th>
            <th>Ký hiệu</th>
            <th>Tiêu Chí</th>
            <th>Điểm tiêu chí</th>
            <th>Mức độ tiêu chí</th>
            <th>Lý do</th>
            <th style="width: 50px;"></th>
          </tr>
          <tr v-for="(item, index) in list_criteria_b" :key="index">
            <td>{{index+1}}</td>
            <td>{{item.code}}</td>
            <td>{{item.name}}</td>
            <td>{{item.point}}</td>
            <td>{{item.level ? item.level.name : ''}}</td>
            <td>{{item.note}}</td>
            <td style="text-align: center;">
              <Button
                @click="ShowItemCriteria(item,index)"
                icon="pi pi-pencil"
                class="button-box p-button-edit"
              />
            </td>
          </tr>
        </table>
      </div>
      <div v-if="total_b && total_b>=0" class="mt-3-custom">
        <div style="padding: 5px;">
          <span class="cs-span" v-html="criteria_level_text_b"></span>
        </div>
      </div>
      <div class="mt-3">
        <label class="txt-right">DANH SÁCH BIỆN PHÁP KIỂM SOÁT</label>
      </div>
      <div class="mt-3">
        <table id="tb_level">
          <tr>
            <th style="width: 60px;">STT</th>
            <th>Loại</th>
            <th>Biện pháp</th>
            <th>Người tạo</th>
            <th>Ngày tạo</th>
            <th>Trạng thái biện pháp</th>
            <th>Cập nhật cuối</th>
            <th style="width: 85px;text-align: center;">
              <Button @click="goPageAddControlMeasures()" icon="pi pi-plus" class="button-box p-button-add"/>
            </th>
          </tr>
          <tr v-for="(item, index) in list_control_measures" :key="index">
            <td>{{index+1}}</td>
            <td>{{item.type_text}}</td>
            <td>{{item.name}}</td>
            <td>{{item.created_name}}</td>
            <td>{{item.date_create}}</td>
            <td>{{item.status_text}}</td>
            <td>{{item.date_update}}</td>
            <td style="text-align: center;">
              <Button
                @click="goPageViewControlMeasures(item,index)"
                icon="pi pi-eye"
                class="button-box p-button-view"
                style="margin:1px"
              />
              <Button
                @click="goPageEditControlMeasures(item,index)"
                icon="pi pi-pencil"
                class="button-box p-button-edit"
                style="margin:1px"
              />
              
            </td>
          </tr>
        </table>
      </div>
      <div class="mt-3">
        <label class="txt-right">ƯỚC TÍNH RỦI RO SAU KHI ÁP DỤNG BIỆN PHÁP KIỂM SOÁT (RE)</label>
      </div>
      <div class="mt-3">
        <table id="tb_level_1">
          <tr>
            <th style="width: 60px;">STT</th>
            <th>Ký hiệu</th>
            <th>Tiêu Chí</th>
            <th>Điểm tiêu chí</th>
            <th>Mức độ tiêu chí</th>
            <th>Mô tả</th>
            <th style="width: 50px;"></th>
          </tr>
          <tr v-for="(item, index) in list_criteria_a" :key="index">
            <td>{{index+1}}</td>
            <td>{{item.code}}</td>
            <td>{{item.name}}</td>
            <td>{{item.point}}</td>
            <td>{{item.level ? item.level.name : ''}}</td>
            <td>{{item.note}}</td>
            <td style="text-align: center;">
              <Button
                @click="ShowItemCriteriaA(item,index)"
                icon="pi pi-pencil"
                class="button-box p-button-edit"
              />
            </td>
          </tr>
        </table>
      </div>
      <div v-if="total_a && total_a>=0" class="mt-3-custom-2">
        <div style="padding: 5px;">
          <span class="cs-span" v-html="criteria_level_text_a"></span>
        </div>
      </div>
      <Toolbar class="fixed-bottom-toolbar">
          <template slot="right">
          <Button
              :label="$constants.TEXT_BUTTON.BACK"
              @click="backToList()"
              class="p-button-warning return-style-button" />
          <Button
              :label="$constants.TEXT_BUTTON.ADD"
              @click="saveData()"
              class="p-button-success main-style-button" />
          </template>
      </Toolbar>
    </div>
    <Dialog :header="hearderTitle('b')" :visible.sync="showEditDialog" :contentStyle="{overflow: 'visible'}" :modal="true" class="dialog-min">
        <div class="">
          <label class="txt-right">Điểm tiêu chí<span class="required"></span></label>
          <Dropdown class="p-col-width-a" v-model="level_edit" :showClear="false" :options="criteria_level_edit"
            optionLabel="point" placeholder="Chọn"
          />
          <input class="input_tmp_validator" id="level" />
        </div>
        <div class="">
          <label class="txt-right">Lý do</label>
          <InputText
            v-model="note"
            type="text"
            class="input-text-box"
            placeholder="Nhập"
          />
          <input class="input_tmp_validator" id="note" />
        </div>
      <template #footer>
        <Button label="Hủy" @click="showEditDialog = false" icon="pi pi-times" class="p-button-cancel" />
        <Button label="Xác nhận" @click="EditData()" icon="pi pi-check" class="" />
      </template>
    </Dialog>
    <Dialog :header="hearderTitle('a')" :visible.sync="showEditDialogA" :contentStyle="{overflow: 'visible'}" :modal="true" class="dialog-min">
        <div class="">
          <label class="txt-right">Điểm tiêu chí<span class="required"></span></label>
          <Dropdown class="p-col-width-a" v-model="level_edit_a" :showClear="false" :options="criteria_level_edit_a"
            optionLabel="point" placeholder="Chọn"
          />
          <input class="input_tmp_validator" id="level_a" />
        </div>
        <div class="">
          <label class="txt-right">Mô tả</label>
          <InputText
            v-model="note_a"
            type="text"
            class="input-text-box"
            placeholder="Nhập"
          />
          <input class="input_tmp_validator" id="note_a" />
        </div>
      <template #footer>
        <Button label="Hủy" @click="showEditDialogA = false" icon="pi pi-times" class="p-button-cancel" />
        <Button label="Xác nhận" @click="EditDataA()" icon="pi pi-check" class="" />
      </template>
    </Dialog>
    <Dialog header="Thông báo" :visible.sync="showDialogWanning" :modal="true" class="dialog-min">
      Bạn vui lòng lưu lại những thông tin đã thay đổi! Bạn chắc chắn muốn chuyển sang trang khác?
      <template #footer>
        <Button label="Hủy" @click="showDialogWanning = false" icon="pi pi-times" class="p-button-cancel" />
        <Button label="Xác nhận" @click="gochangPage()" icon="pi pi-check" class="" />
      </template>
    </Dialog>
  </form>
</template>

<script>
import moment from "moment-timezone";
import ApiRepository from "@/core/ApiRepository";
// import DropdownScrollable from '@/components/DropdownScrollable';
export default {
    components: {
        // DropdownScrollable
    },
    props: {
      model: Object,
      users: Array,
      company_id: String 
    },
    data() {
      return {
        time_zone_local : moment.tz.guess(true),
        company: null,
        evaluation_name : "",
        title_1 : '',
        title_2 : '',
        title_3 : '',
        formula : null,
        list_criteria_b : [],
        list_criteria_a : [],
        criteria_level_edit : null,
        level_edit : null,
        code_header : '',
        name_header : '',
        note : '',
        criteria_level_edit_a : null,
        level_edit_a : null,
        code_header_a : '',
        name_header_a : '',
        note_a : '',
        // json_list_criteria : [],
        showEditDialog : false,
        index_criteria_level_b : -1,
        criteria_level_text_b : '',
        total_b : null,
        text_b : '',
        code_b : '',
        criteria_level_text_a: '',
        total_a : null,
        text_a : '',
        code_a : '',
        ids_in_formula : [],
        type_formula : '',
        showEditDialogA : false,
        evaluation_form_id : null,
        list_control_measures : [],
        showDialogWanning : false,
        item_gopage : {
          type : '',
          item : {}
        },
        id_a : null,
        id_b : null,
      }
    },
    watch: {
        
    },
    async mounted() {
      var title_1 = ''
      var title_2 = ''
      if (this.model !== undefined && Object.keys(this.model).length > 0) {
        console.log("this.model==",this.model)
        if(this.model.company){
          title_1 += this.model.company.name
        }
        this.getListControlMeasures();//danh sách BPKS
        if(this.model.evaluation_form){
          this.evaluation_form_id = this.model.evaluation_form.id
          this.evaluation_name = this.model.evaluation_form.name
          if(this.model.evaluation_form.areas){
            title_1 += ' / '+this.model.evaluation_form.areas.name
          }
          if(this.model.evaluation_form.department){
            title_1 += ' / '+this.model.evaluation_form.department.name
          }
          if(this.model.evaluation_form.work){
            title_2 += this.model.evaluation_form.work.name
          }
        }
        if(this.model.situation){
          if(this.model.situation.type == 'other'){
            title_2 += ' / '+this.model.other_situation_name
          }else{
            title_2 += ' / '+this.model.situation.name
          }
        }
        if(this.model.type == 'PERIODIC'){
          title_2 += ' (Phân loại: Định kỳ)'
        }else if(this.model.type == 'ABMORMAL'){
          title_2 += ' (Phân loại: Bất thường)'
        }else if(this.model.type == 'FREQUENT'){
          title_2 += ' (Phân loại: Thường xuyên)'
        }
        if(this.model.category){
          this.title_3 = this.model.category.name
        }
        this.title_1 = title_1
        this.title_2 = title_2
        await this.getformula()
      }
    },
    methods: {
      async EditData(){
        var validate = await this.checkValidataEdit()
        if(validate){
          // this.$commonFuction.is_loading(false);
          return
        }
        if(this.index_criteria_level_b >= 0){
          var index = this.index_criteria_level_b
          var tmp = this.list_criteria_b[index]
          tmp.level = this.level_edit
          tmp.point = this.level_edit.point
          tmp.note = this.note
          // console.log("tmp",tmp)
          this.list_criteria_b[index] = tmp
        }
        this.showEditDialog = false;
        // console.log("this.list_criteria_b",this.list_criteria_b)
        // console.log("this.list_criteria_a",this.list_criteria_a)
        //gọi hàm tính toán
        await this.calPoint('b')
      },
      async EditDataA(){
        var validate = await this.checkValidataEditA()
        if(validate){
          // this.$commonFuction.is_loading(false);
          return
        }
        if(this.index_criteria_level_a >= 0){
          var index = this.index_criteria_level_a
          var tmp = this.list_criteria_a[index]
          tmp.level = this.level_edit_a
          tmp.point = this.level_edit_a.point
          tmp.note = this.note_a
          // console.log("tmp",tmp)
          this.list_criteria_a[index] = tmp
        }
        this.showEditDialogA = false;
        //gọi hàm tính toán
        await this.calPoint('a')
      },
      async calPoint(key = 'b'){
        var formula = this.formula.dataValues.value
        if(key=='b'){//trước
          if(formula && formula !==''){
            let list_data = {}
            let check_choose = true //kiểm tra có chọn hết điểm hay không
            for (let i = 0; i < this.list_criteria_b.length; i++) {
              let e = this.list_criteria_b[i];
              if(e.point && e.point >= 0){
                list_data[e.id] = e.point
              }else{
                check_choose = false
                break;
              }
            }
            if(check_choose == false){
              this.total_b = -1
              return;
            }
            let new_point = formula
            for (let j = 0; j < this.ids_in_formula.length; j++) {
              let el = this.ids_in_formula[j];
              new_point = new_point.replaceAll(el,list_data[el])
            }
            if(new_point){
              this.total_b = eval(new_point)
              await this.getTextDanger('b')
            }
            // console.log("this.total_b ",this.total_b)
            return;
          }else{
            this.total_b = -1
            return;
          }
        }else{
          if(formula && formula !==''){
            let list_data = {}
            let check_choose = true //kiểm tra có chọn hết điểm hay không
            for (let i = 0; i < this.list_criteria_a.length; i++) {
              let e = this.list_criteria_a[i];
              if(e.point && e.point >= 0){
                list_data[e.id] = e.point
              }else{
                check_choose = false
                break;
              }
            }
            if(check_choose == false){
              this.total_a = -1
              return;
            }
            let new_point = formula
            for (let j = 0; j < this.ids_in_formula.length; j++) {
              let el = this.ids_in_formula[j];
              new_point = new_point.replaceAll(el,list_data[el])
            }
            if(new_point){
              this.total_a = eval(new_point)
              await this.getTextDanger('a')
            }
            return;
          }else{
            this.total_a = -1
            return;
          }
        }
      },
      async checkValidataEdit(){
        let level_edit = document.getElementById("level");
        if (!this.level_edit) {
          level_edit.setCustomValidity("Điểm tiêu chí không được để trống!");
        } else {
          level_edit.setCustomValidity("");
        }
        var inpObj = document.getElementById("frm_action");
        if (!inpObj.checkValidity()) {
          inpObj.reportValidity();
          return true;
        }
      },
      async checkValidataEditA(){
        let level_edit = document.getElementById("level_a");
        if (!this.level_edit_a) {
          level_edit.setCustomValidity("Điểm tiêu chí không được để trống!");
        } else {
          level_edit.setCustomValidity("");
        }
        var inpObj = document.getElementById("frm_action");
        if (!inpObj.checkValidity()) {
          inpObj.reportValidity();
          return true;
        }
      },
      ShowItemCriteria(item,index){
        var data = item
        this.index_criteria_level_b = index
        this.code_header = data.code
        this.name_header = data.name
        this.criteria_level_edit = data.criteria_level
        this.level_edit = data.level
        this.note = data.note
        this.showEditDialog = true;
      },
      ShowItemCriteriaA(item,index){
        var data = item
        this.index_criteria_level_a = index
        this.code_header_a = data.code
        this.name_header_a = data.name
        this.criteria_level_edit_a = data.criteria_level
        this.level_edit_a = data.level
        this.note_a = data.note
        this.showEditDialogA = true;
      },
      hearderTitle(key='b'){
        var text = ''
        if(key=='b'){
          text = `Đánh giá rủi ro - `+this.name_header+` (`+this.code_header+`)`
        }else{
          text = `Đánh giá rủi ro - `+this.name_header_a+` (`+this.code_header_a+`)`
        }
        return text
      },
      async getformula(){
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
          const headers = {
            "Authorization": "Bearer "+token,
          };
          let {data} = await ApiRepository.post("/_api/formula/detail", {company_id: this.company_id}, {headers});
          var value = data.data;
          if(this.$commonFuction.isEmptyObject(value) || this.$commonFuction.isEmpty(value)){
            alert("Vui lòng thêm công thức trước khi đánh giá! Bạn sẽ được chuyển đến trang cấu hình công thức ngay.")
            this.$router.push({ path: '/admin/formula', query: {company_id: this.company_id}});
            return
          }
          this.formula = value;
          // console.log("this.formula",this.formula)
          var list_ids = []
          if(this.formula.dataValues){
            this.type_formula = this.formula.dataValues.type
            var arr_ids = []
            var mylist_ids = this.formula.dataValues.value.split(" + ");
            for (let i = 0; i < mylist_ids.length; i++) {
              var ids = mylist_ids[i].split("*")
              arr_ids=[...arr_ids,...ids]
            }
            list_ids = Array.from(new Set(arr_ids))
            this.ids_in_formula = list_ids
          }
          if(list_ids.length > 0){
            let {data} = await ApiRepository.post("/_api/criteria/list_evluation", {list_ids : list_ids,company_id: this.company_id}, {headers});
            var tmp = data.data ?? []
            var list_data = []
            var list_data_a = []
            
            var map_dd = []
            for (let k = 0; k < this.model.risk_assessment.length; k++) {
              const ek = this.model.risk_assessment[k];
              map_dd[ek.criteria_id] = ek
            }
            // console.log("map_dd",map_dd)
            // console.log("risk_assessment_re",this.model.risk_assessment_re)
            var map_dd1 = []
            for (let m = 0; m < this.model.risk_assessment_re.length; m++) {
              const ek1 = this.model.risk_assessment_re[m];
              map_dd1[ek1.criteria_id] = ek1
            }
            // console.log("map_dd1",map_dd1)
            for (let j = 0; j < tmp.length; j++) {
              let dd = {
                id : tmp[j].id,
                name : tmp[j].name,
                code : tmp[j].code,
                criteria_level : tmp[j].criteria_level,
                point : map_dd[tmp[j].id] ? map_dd[tmp[j].id].point : null,
                note : (map_dd[tmp[j].id] && map_dd[tmp[j].id].note)? map_dd[tmp[j].id].note : null,
                level : map_dd[tmp[j].id] ? map_dd[tmp[j].id].criteria_json?.level : null,
              }
              let dd1 = {
                id : tmp[j].id,
                name : tmp[j].name,
                code : tmp[j].code,
                criteria_level : tmp[j].criteria_level,
                point : map_dd1[tmp[j].id] ? map_dd1[tmp[j].id].point : null,
                note : (map_dd1[tmp[j].id] && map_dd1[tmp[j].id].note) ? map_dd1[tmp[j].id].note : null,
                level : map_dd1[tmp[j].id] ? map_dd1[tmp[j].id].criteria_json?.level : null,
              }
              list_data.push(dd)
              list_data_a.push(dd1)
            }
            // console.log("list_data_a",list_data_a)
            // console.log("list_data_b",list_data)
            this.list_criteria_b = list_data
            this.list_criteria_a = list_data_a
            this.calPoint('a')
            this.calPoint('b')
          }
          
        }


      },
      async getTextDanger(key='a'){
        var text = ''
        if(key == 'b' && this.total_b >=0){
          let data = await this.getDataRick(this.total_b)
          if(data){
            if(this.type_formula == 'MATRIX'){
              if(data.risk_color){
                this.code_b = data.risk_color.name ?? ''
                this.text_b = data.risk_color.description ?? ''
                this.id_b =  data.id ?? null
              }
            }else{
              this.code_b = data.code ?? ''
              this.text_b = data.description ?? data.description
              this.id_b =  data.id ?? null
            }
          }
          text = `Điểm đánh giá (R): <span class="tx-b">`+this.total_b+`</span>`
          if(this.code_b){
            text += ` - Mức độ rủi ro: <span class="tx-b">`+this.code_b+`</span>`
          }
          if(this.text_b){
            text += ` - <span class="tx-b">`+this.text_b+`</span>`
          }
          this.criteria_level_text_b = text
        }else if(key == 'a' && this.total_a >=0){
          let data = await this.getDataRick(this.total_a)
          if(data){
            if(this.type_formula == 'MATRIX'){
              if(data.risk_color){
                this.code_a = data.risk_color.name ?? ''
                this.text_a = data.risk_color.description ?? ''
                this.id_a =  data.id ?? null
              }
            }else{
              this.code_a = data.code ?? ''
              this.text_a = data.description ?? data.description
              this.id_a =  data.id ?? null
            }
          }
          text = `Điểm đánh giá (R<sub>e</sub>): <span class="tx-b">`+this.total_a+`</span>`
          if(this.code_a){
            text += ` - Mức độ rủi ro: <span class="tx-b">`+this.code_a+`</span>`
          }
          if(this.text_a){
            text += ` - <span class="tx-b">`+this.text_a+`</span>`
          }
          this.criteria_level_text_a = text
        }
      },
      async getDataRick(point){
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
          const headers = {
            "Authorization": "Bearer "+token,
          };
          if(this.type_formula){
            var {data} = await ApiRepository.post("/_api/formula/risk_point", {type :this.type_formula,point : point, company_id: this.company_id}, {headers});
            var value = data.data;
            return value
          }
          return null
        }
      },
      goPageAddControlMeasures(){
        this.showDialogWanning = true
        this.item_gopage = {
          type : 'add',
          item : {}
        }
        // this.$router.push({ path: '/admin/control_measures/add', query: {company_id: this.company_id,efd_id : this.$route.params.id}});
        // this.$router.push({ path: '/admin/control_measures/add', query: {company_id: this.company_id} });
      },
      goPageEditControlMeasures(item){
        this.showDialogWanning = true
        this.item_gopage = {
          type : 'edit',
          item : item
        }
        // this.$router.push({ path: '/admin/control_measures/edit/'+item.id, query: {company_id: this.company_id}});
        // this.$router.push({ path: '/admin/control_measures/add', query: {company_id: this.company_id} });
      },
      goPageViewControlMeasures(item){
        this.showDialogWanning = true
        this.item_gopage = {
          type : 'view',
          item : item
        }
        // this.$router.push({ path: '/admin/control_measures/edit/'+item.id, query: {company_id: this.company_id}});
        // console.log("item",item)
        // alert("chưa phát triển")
        // this.$router.push({ path: '/admin/control_measures/view/'+item.id, query: {company_id: this.company_id}});
        // this.$router.push({ path: '/admin/control_measures/add', query: {company_id: this.company_id} });
      },
      saveData(){
        this.$commonFuction.is_loading(true);
        //kiểm tra có cấu hình điểm hay không
        var check_data_save = false
        var check_b = false
        for (let i = 0; i < this.list_criteria_b.length; i++) {
          const e1 = this.list_criteria_b[i];
          if(e1.point == null || e1.level == null){
            check_b = true;
          }else{
            check_data_save = true;
          }
        }
        var check_a = false
        if(check_data_save == false){
          for (let i = 0; i < this.list_criteria_a.length; i++) {
            const ea1 = this.list_criteria_a[i];
            if(ea1.point == null || ea1.level == null){
              check_a = true
            }else{
              check_data_save = true;
            }
          }
        }
        if(check_data_save == false){
          this.$commonFuction.is_loading(false);
          alert("Vui nhập ít nhất một đánh giá rủ ro.")
          return;
        }
        if(check_b == true){
          var count_null_b = 0
          for (let j = 0; j < this.list_criteria_b.length; j++) {
            const e = this.list_criteria_b[j];
            if(e.point == null || e.level == null){
              count_null_b++
            }
          }
          if(count_null_b > 0 && count_null_b !== this.list_criteria_b.length){
            this.$commonFuction.is_loading(false);
            alert("Vui lòng chọn đầy đủ điểm đánh giá rủi ro.")
            return;
          }
        }

        if(check_a == true){
          var count_null_a = 0
          for (let j = 0; j < this.list_criteria_a.length; j++) {
            const ea = this.list_criteria_a[j];
            if(ea.point == null || ea.level == null){
              count_null_a++
            }
          }
          if(count_null_a > 0 && count_null_a !== this.list_criteria_a.length){
            this.$commonFuction.is_loading(false);
            alert("Vui lòng chọn đầy đủ điểm đánh giá rủi ro sau khi áp dụng biện pháp.")
            return;
          }
        }

        var params = {
          // company: this.company,
          id : this.$route.params.id,
          company_id: this.company_id,
          list_criteria_b : this.list_criteria_b,
          code_rb : this.code_b,
          point_rb : this.total_b,
          id_rb: this.id_b,
          text_b : this.text_b,
          list_criteria_a : this.list_criteria_a,
          code_re : this.code_a,
          point_re : this.total_a,
          id_re : this.id_a,
          text_a : this.text_a,
          formula_value : this.formula?.dataValues?.value,
          type_formula : this.formula?.dataValues?.type,
          evaluation_form_id : this.evaluation_form_id,
        };
        console.log("params",params)
        this.$emit("save", params);
      },
      async getListControlMeasures(){
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
          const headers = {
            "Authorization": "Bearer "+token,
          };
          var filters = {
            evaluation_form_id : this.evaluation_form_id,
            danger_id : this.model.danger_id,
            situation_id : this.model.situation_id,
          }
          var {data} = await ApiRepository.post("/_api/control_measures/list_by_evaluation_form", {filters,company_id: this.company_id}, {headers});
          var value = data.data;
          // console.log("value===",value)
          var tmp = value
          for (let i = 0; i < tmp.length; i++) {
            if(tmp[i].type == 'TIME'){
              tmp[i].type_text = 'Có thời hạn'
              if(tmp[i].status == 'WAITING'){
                tmp[i].status_text = 'Đề xuất'
              }else if(tmp[i].status == 'APPROVE'){
                tmp[i].status_text = 'Đã duyệt'
              }else if(tmp[i].status == 'NOT_APPROVE'){
                tmp[i].status_text = 'Không duyệt'
              }
            }else if(tmp[i].type == 'LOOP'){
              tmp[i].type_text = 'Lặp lại'
              if(tmp[i].status == 'WAITING'){
                tmp[i].status_text = 'Đề xuất'
              }else if(tmp[i].status == 'APPROVE'){
                tmp[i].status_text = 'Đã duyệt'
              }else if(tmp[i].status == 'NOT_APPROVE'){
                tmp[i].status_text = 'Không duyệt'
              }else if(tmp[i].status == 'CANCEL'){
                tmp[i].status_text = 'Đã hủy'
              }
            }
            tmp[i].date_create = moment.tz(tmp[i].created_at, this.time_zone_local).format("DD/MM/yyyy");
            tmp[i].date_update = moment.tz(tmp[i].updated_at, this.time_zone_local).format("DD/MM/yyyy HH:mm");
          }
          this.list_control_measures = value;
        }
      },
      backToList() {
        this.$emit("back");
      },
      gochangPage(){
        var type = this.item_gopage.type
        var item = this.item_gopage.item
        if(type == 'add'){
          this.$router.push({ path: '/admin/control_measures/add', query: {company_id: this.company_id,efd_id : this.$route.params.id}});
        }else if(type == 'edit'){
          this.$router.push({ path: '/admin/control_measures/edit/'+item.id, query: {company_id: this.company_id}});
        }else if(type == 'view'){
          this.$router.push({ path: '/admin/control_measures/edit/'+item.id, query: {company_id: this.company_id}});
        }
      }
    }
}
</script>

<style lang="scss">
label {
  font-weight: bold;
}
.button-clear {
  position: absolute;
  background-color: red;
  border-radius: 50%;
  right: 0;
  top: 0;
  width: 20px;
  height: 20px;
  padding: 0;
  display: flex;
  cursor: pointer;
}
.item-img {
  width: 80px;
  height: 80px;
  position: relative;
  padding: 0;
}
.p-password .pi.pi-eye {
  color: #000;
  font-size: 14px;
}
.p-checkbox {
  margin-right: 1rem !important;
}
.cus-number {
  font-weight: 700;
  color : #0086c4;
}
#tb_level {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#tb_level td, #customers th {
  border: 1px solid #ddd;
  padding: 8px;
}
#tb_level th {
  border: 1px solid #ddd;
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  padding-left: 5px;
}
.cus-r {
  width: auto;
}
.dialog-min {
  width : 450px
}
.p-button-cancel{
  background: #FFFAF0;
  border: 1px solid #d0dde7;
  color : #000000
}
.svg-cus-1{
  margin-right: 3px;
}
.cuss-text{
  padding-top: 6px;
}
.cust-name{
  color : #0086C4;
  font-size : 24px;
  font-weight : 600;
}
.cs-span{

}
.mt-3-custom{
  /* min-height: 30px; */
  background-color: #FFFCE8;
  border-radius: 5px;
  margin-top: 8px;
}
.mt-3-custom-2{
  /* min-height: 30px; */
  background-color: #EAFFE8;
  border-radius: 5px;
  margin-top: 8px;
}

.tx-b {
  font-weight: 700;
}
#tb_level_1 {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#tb_level_1 td, #customers th {
  border: 1px solid #ddd;
  padding: 8px;
}
#tb_level_1 th {
  border: 1px solid #ddd;
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  padding-left: 5px;
}
</style>
